import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isEmpty'
})
export class IsEmptyPipe implements PipeTransform {

  transform(value: any): boolean {
    if (Array.isArray(value)) {
      return value.length < 1;
    } else if (typeof value === 'object') {
      for (let key in value) return false;
      return true;
    } else {
      return !!value;
    }
  }
}
